import jQuery from "jquery";
// eslint-disable-next-line no-unused-vars
import 'datatables.net';
import 'datatables.net-rowgroup';
import updateQueryStringParameter from "../../foundation/utilities/update-querystring";
import BaseBehavior from "../../foundation/base/base";
import {
	detectBrowser,
	Browsers,
} from "../../foundation/utilities/detectBrowsers";

export class SearchFilterbarBase extends BaseBehavior {
	constructor(element) {
		super(element);

		this.el = element;
		this.settings = this.parseSettings();

		this.firstSubmit = false;
		this.firstLoad = true;
		this.reset = false;
		this.knowledgeFirstSubmit = false;
		// eslint-disable-next-line max-len
		this.showFirstHeaderInfo = false; // in news, inspector reports and publications we show special header info on first load only
		this.$datatable = "";
		this.$container = "";
		this.isSitecore = document.body.classList.contains("scPageEdit");
		this.baseUrl =
			window.location.protocol +
			"//" +
			window.location.host +
			window.location.pathname;
		this.url =
			window.location.protocol +
			"//" +
			window.location.host +
			window.location.pathname;
		this.selectBoxes = document.querySelectorAll(".m-select__select");
		this.selectBoxValues = [];
		this.dataTableColumns = []; // this variable manipulates json data rendering in the datatable
		this.dataTableDefs = []; // this variable injects css-class names to each datatable cell
		this.headerString = "";
		this.columnsHeaderOne = this.settings.columnsHeader1;
		this.searchFilters = document.querySelectorAll(".m-form-group-select");
		this.cludoFilterHeaders = document.querySelectorAll(
			'[data-ref="search-filterbar__filters"] .search-filter-header'
		);
		this.searchBarSelect = document.querySelectorAll(
			'[data-ref="search-filterbar__filters"] select'
		);
		this.KnowledgeClose = document.querySelector('[data-js="close"]');
		this.searchFilterSubmit = this.el.querySelector(
			'[data-ref="search-filterbar__submit"]'
		);
		this.searchFilterReset = this.el.querySelector(
			'[data-ref="search-filterbar__reset"]'
		);

		this.hideSerieButton();

		this.addEventListener();

		const isIE = detectBrowser(Browsers.IE);
		if (isIE) {
			document.body.classList.add("is-explorer");
		}
		this.log("SearchFilterbarBase");
	}

	finishSetup(initDataTablesFunc, totalHitsRender) {
		this.initDataTablesFunc = initDataTablesFunc;
		this.totalHitsRender = totalHitsRender;

		if (!(this.totalHitsRender instanceof Function)) {
			console.error("SearchFilterbarBase.totalHitsRender is not set");
		}

		this.setSelectboxValues();
	}

	initDataTablesIsSet() {
		if (this.initDataTablesFunc instanceof Function) {
			return true;
		}
		console.error("SearchFilterbarBase.initDataTablesFunc is not set");
		return false;
	}

	// Eventlisteners for form fields
	addEventListener() {
		if (this.selectBoxes) {
			for (let i = 0; i < this.selectBoxes.length; i++) {
				this.selectBoxes[i].addEventListener("change", () =>
					this.getSelectValues(true)
				);
			}
		}
		this.dom.input.addEventListener("keydown", (e) => this.submitOnEnter(e));
		this.dom.submit.addEventListener("click", (e) => this.submitClick(e));
		this.dom.reset.addEventListener("click", (e) => this.resetFiltering(e));
		if (this.KnowledgeClose) {
			this.KnowledgeClose.addEventListener("click", (e) => this.resetFiltering(e)
			);
		}
		
		if (this.searchFilterReset) {
			this.searchFilterReset.addEventListener("click", (e) => this.resetFiltering(e)
			);
		}

		if (this.searchFilterReset) {
			this.searchFilterReset.addEventListener("click", (e) =>
				this.resetFiltering(e)
			);
		}

		if (this.searchBarSelect) {
			for (let i = 0; i < this.searchBarSelect.length; i++) {
				const filter = this.searchBarSelect[i];
				filter.classList.add("m-select__select--hide-outline");

				filter.addEventListener("click", () => {
					filter.classList.add("m-select__select--hide-outline");
				});

				filter.addEventListener("keyup", (e) => {
					if (e.code === "Tab") {
						filter.classList.remove("m-select__select--hide-outline");
					}
				});
			}
		}

		if (this.cludoFilterHeaders) {
			for (let i = 0; i < this.cludoFilterHeaders.length; i++) {
				const filter = this.cludoFilterHeaders[i];
				filter.classList.add("cludo-filters--hide-outline");

				filter.addEventListener("click", () => {
					filter.classList.add("cludo-filters--hide-outline");
				});

				filter.addEventListener("keyup", (e) => {
					if (e.code === "Tab") {
						filter.classList.remove("cludo-filters--hide-outline");
					}
				});
			}
		}

		if (this.searchFilterSubmit) {
			this.searchFilterSubmit.classList.add("mouse-focus");
			this.searchFilterSubmit.addEventListener("keyup", (e) => {
				if (e.code === "Tab") {
					this.searchFilterSubmit.classList.remove("mouse-focus");
				}
			});

			this.searchFilterSubmit.addEventListener("mousedown", () => {
				this.searchFilterSubmit.classList.add("mouse-focus");
			});
		}
	}

	// get data-attribute values as JSON from the HTML
	parseSettings() {
		const settings = this.element.getAttribute("data-settings");
		return JSON.parse(settings);
	}

	// Get the querystring parameters and values from the url
	getUrlParameters(name) {
		this.name = encodeURIComponent(
			name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]")
		);
		this.regex = new RegExp("[\\?&]" + this.name + "=([^&#]*)");
		this.results = this.regex.exec(window.location.search);
		return this.results === null
			? ""
			: decodeURIComponent(this.results[1].replace(/\+/g, " "));
	}

	// If the user comes directly to a list-page with prefixed filters (through querystrings),
	// we detect the filter parameters and call the datatable load function with applied filters
	setSelectboxValues() {
		this.hasParameters = false;
		for (let i = 0; i < this.selectBoxes.length; i++) {
			const paramValue = this.getUrlParameters(this.selectBoxes[i].name);
			if (paramValue !== "") {
				this.selectBoxes[i].value = paramValue;
				this.selectBoxValues.push(this.selectBoxes[i].value);
				this.hasParameters = true;
			}

			const searchPhrase = this.getUrlParameters("searchWord");
			if (searchPhrase) {
				this.dom.input.value = searchPhrase;
				this.hasParameters = true;
			}
		}
		// So, if the url contains parameters we trigger a submit to load the datatable
		if (this.hasParameters === true) {
			this.dom.reset.classList.remove("js-hidden");
			// But only if we're not in Sitecore experience Editor
			if (!this.isSitecore && this.initDataTablesIsSet()) {
				this.initDataTablesFunc();
			}
		}
	}

	// eslint-disable-next-line max-len
	// The function is called onchange from each select. It does 2 things while looping through the selectboxes:
	// 1. Reload the datatable with the new selected filter
	// eslint-disable-next-line max-len
	// 2. Append the selected filter in the Adress bar (without reloading), for easy link copy for the sitecore editor
	getSelectValues(reload) {
		this.selectBoxValues = []; // empty the array
		const searchPhrase = this.getUrlParameters("searchWord");
		const showSerie = this.getUrlParameters("showSerie");
		let hasPhrase = false;
		if (searchPhrase) {
			hasPhrase = true;
			// eslint-disable-next-line no-unused-expressions
			this.url = this.baseUrl;
			// eslint-disable-next-line no-unused-expressions
			+"?searchWord=" + this.dom.input.value; // clean url parameters but keep the typed search phrase
		} else {
			this.url = this.baseUrl; // clean url parameters
		}

		for (let i = 0; i < this.selectBoxes.length; i++) {
			if (this.selectBoxes[i].value !== "") {
				if (this.settings.searchType === 'fou-search-global') {
					const selectBox = this.selectBoxes[i];
					const { options } = selectBox;
					this.selectBoxValues.push(options[selectBox.selectedIndex].text);
				} else {
					this.selectBoxValues.push(this.selectBoxes[i].value);
				}
				this.url +=
					(this.url.split("?")[1] ? "&" : "?") +
					this.selectBoxes[i].name +
					"=" +
					this.selectBoxes[i].value;
			}
		}
		if (hasPhrase) {
			this.url +=
				(this.url.split("?")[1] ? "&" : "?") +
				"searchWord=" +
				this.dom.input.value;
			window.history.replaceState({ path: this.url }, "", this.url);
		}
		if (showSerie === "true") {
			this.url += (this.url.split("?")[1] ? "&" : "?") + "showSerie=true";
			window.history.replaceState({ path: this.url }, "", this.url);
			this.showSerieButton();
		} else {
			window.history.replaceState({ path: this.url }, "", this.url);
		}

		if (reload) {
			this.submitClick();
		}
	}

	// Load the datatable or just reload if user searchs again
	submitClick(e, reset) {
		this.reset = false;
		if (this.firstSubmit === false) {
			this.getSelectValues(false);
			// this.initDataTables(); // Here we are looking up which search-type we have.

			if (this.initDataTablesIsSet()) {
				this.initDataTablesFunc();
			}
			this.firstSubmit = true;
			// In all lists except knowledge we render on load
			if (
				this.settings.searchType !== "knowledge" &&
				this.settings.searchType !== "vvae" &&
				this.settings.searchType !== "enafos" &&
				this.settings.searchType !== "fou-search-global"
			) {
				this.$container.removeClass("js-hidden");
				this.dom.filters.classList.remove(
					"o-search-filterbar__container-second--hidden"
				);
			}

			// On knowledge we do not render list until user has interacted
		} else if (
			(this.settings.searchType === "knowledge" ||
				this.settings.searchType === "vvae" ||
				this.settings.searchType === "enafos") &&
			this.firstSubmit === true
		) {
			// OK, in knowledge we also have tot test if datatables has been initalized, if so only reload
			if (this.knowledgeFirstSubmit === false) {
				this.initDataTableList();
			} else {
				this.datatableReload();
			}

			this.$container.removeClass("js-hidden");
			this.dom.reset.classList.remove("js-hidden");
			this.dom.filters.classList.remove(
				"o-search-filterbar__container-second--hidden"
			);
		} else {
			this.datatableReload();
			this.dom.reset.classList.remove("js-hidden");
			this.$container.removeClass("js-hidden");

			updateQueryStringParameter("searchWord", this.dom.input.value, this);
		}
		if (e) {
			e.preventDefault();
		}
		if (reset) {
			this.reset = true;
			this.showFirstHeaderInfo = true;
			this.datatableReload();
		}
	}

	// Avoid form postback and just do the Ajax thing when hitting enter
	submitOnEnter(e) {
		if (e.keyCode === 13) {
			this.submitClick();
			e.preventDefault();
		}
	}

	// Reset everything when clicking the reset button
	resetFiltering(e) {
		if (this.firstSubmit === true) {
			this.firstSubmit = false;

			if (document.querySelector(".js-search-list-header")) {
				document.querySelector(".js-search-list-header").innerHTML = "";
			}

			this.$container.addClass("js-hidden");
			this.dom.filters.classList.add(
				"o-search-filterbar__container-second--hidden"
			);
			this.selectBoxValues = []; // empty the array
			this.showFirstHeaderInfo = true;
			this.dom.form.reset();

			// eslint-disable-next-line no-underscore-dangle
			let _reset = true;
			if (
				this.settings.searchType === "knowledge" ||
				this.settings.searchType === "vvae" ||
				this.settings.searchType === "enafos"
			) {
				_reset = false;
			}

			this.submitClick(e, _reset);

			// eslint-disable-next-line prefer-destructuring
			this.url = this.url.split("?")[0]; // Remove all parameters
			window.history.replaceState({ path: this.url }, "", this.url);
		}
		if (
			this.settings.searchType === "news" ||
			this.settings.searchType === "puljer"
		) {
			this.showFirstHeaderInfo = false;
		}
		this.dom.reset.classList.add("js-hidden");
		e.preventDefault();
	}

	// eslint-disable-next-line class-methods-use-this
	rowClick() {
		if (!jQuery(".dataTable--empty")[0]) {
			// eslint-disable-next-line func-names
			jQuery(".js-row-hover tbody tr.o-search-result-materials__row").on("click", function () {
					const rowUrl = jQuery(this).find("td a").attr('href');
					document.location.href = rowUrl;
				}
			);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	hideSerieButton() {
		const serieFilter = document.querySelector("select[name=Serie]");
		if (serieFilter) {
			serieFilter.closest(".m-form-group-select").classList.add("js-hidden");
		}
	}

	// eslint-disable-next-line class-methods-use-this
	showSerieButton() {
		document
			.querySelector("select[name=Serie]")
			.closest(".m-form-group-select")
			.classList.remove("js-hidden");
	}

	// Ajax reload and callback functions after reload
	datatableReload() {
		this.$datatable.DataTable().ajax.reload(this.totalHitsRender());
	}

	// If there are no results. We add a class to parent row for styling in events list...
	// eslint-disable-next-line class-methods-use-this
	ifNoResults() {
		jQuery(".dataTable").removeClass("js-row-hover");
		jQuery(".dataTable").addClass("dataTable--empty");
	}
}

export default SearchFilterbarBase;
